/**
 * HistorySheet - 返却済み (履歴) の本の一覧を出すシート
 *
 * 履歴は見る頻度が低いためタブには置かず、ヘッダーメニューから開く。
 * お気に入りは画面を開いたときに全状態まとめて取得済み (検索結果の☆判定に全 ISBN が要るため) なので、
 * ここでは追加の取得をしない。
 */

import { BottomSheet } from '@/components/ui/bottom-sheet'

import { FavoriteBooksPanel } from './FavoriteBooksPanel'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  expandedBookIds: ReadonlySet<string>
  onToggle: (bookId: string) => void
}

export const HistorySheet = ({ open, onOpenChange, expandedBookIds, onToggle }: Props) => (
  <BottomSheet title="履歴" open={open} onOpenChange={onOpenChange} snapPoints={[0.92]}>
    <div className="px-4 pb-6">
      <FavoriteBooksPanel status="returned" expandedBookIds={expandedBookIds} onToggle={onToggle} />
    </div>
  </BottomSheet>
)
